import lodash from "lodash";
import moment from "moment";

export const rowClassNameStatusColor = ({ record, expireDate, refStatusKey }) => {
    let css = "";
    if (record.isActive === false) {
        css += " bg-inactive";
    }
    const expDate = !expireDate ? record?.expireDate : expireDate;
    const statusKey = !refStatusKey ? record?.refStatus?.key : refStatusKey;
    if (statusKey === "cancel") {
        css += " text-danger"
    } else if (statusKey === "suspend") {
        css += " text-orange"
    } else if (statusKey === "process") {
        css += " text-blue"
    } else if (expDate) {
        const diff = moment().diff(expDate, 'days');
        if (diff >= 0) {
            css += " bg-inactive"
        }
    }
    return lodash.trim(css);
}